<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <sui-grid
        ref="grdList1"
        :showCountControl="true"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns"
        :columnsresize="true"
        :columnsautoresize="true"
        :enabletooltips="true"
        width="100%"
        :dataset="'dsData1'"
        :initialPagesize="15"
      />
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'PGE_CMA_00013',
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {
    this.localdata1 = [];
    this.gridColumns = [
      {
        text: this.$t('MSG_TXT_TASK_TYPE'),
        datafield: 'taskName',
      },
      {
        text: this.$t('MSG_TXT_USER_GROUP'),
        datafield: 'userGroupName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onSelectUserGroup,
            type: 'link',
          }, this.dsData1, this.$refs.grdList1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_VALID_PERIOD'),
        datafield: 'validFinishDT',
        width: 90,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.dsData1, this.$refs.grdList1),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),      
      },
      {
        text: this.$t('MSG_TXT_APPROVER'),
        datafield: 'firstRegistrationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'authApprovalDisplayLangId',
              knoxId: 'authApprovalKnoxId',
              loginId: 'authApprovalLoginId',
              userName: 'authApprovalUserName',
              userGlobalName: 'authApprovalUserGlobalName',
            },
          }, this.dsData1, this.$refs.grdList1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 200,
      },
      {
        text: this.$t('MSG_TXT_APPR_DTM'),
        datafield: 'firstRegistrationDTM',
        width: 150,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsData1, this.$refs.grdList1),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }];
  },
  datasets: [{
    id: 'dsData1',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'firstRegistrationDTM', type: 'string',  map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'authApprovalUserGlobalName', type: 'string', map: 'authApprovalUserGlobalName' },
      { name: 'authApprovalDisplayLangId', type: 'string', map: 'authApprovalDisplayLangId' },
      { name: 'authApprovalKnoxId', type: 'string', map: 'authApprovalKnoxId' },
      { name: 'authApprovalLoginId', type: 'string', map: 'authApprovalLoginId' },
      { name: 'authApprovalUserName', type: 'string', map: 'authApprovalUserName' },
      { name: 'validFinishDT', type: 'string', map: 'validFinishDT' },
    ],
  }],
  mounted() {
    this.load();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    load() {
      this.searchData();
    },
    searchData() {
      http.request(this.$options.name, 'DTS_CMA_00056', {
      }).then(res => {
        this.dsData1.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onSelectUserGroup(btn, dataRow) {
      utils.openLayerPopup('PGE_CMA_00015', this.onPagePopupCallback, {
        pageInitialData: {
          userGroupId: dataRow.userGroupId,
        },
        size: 'lg',
      });
    },
  },
};
</script>
<style scoped>
</style>
